module.exports = __webpack_public_path__ + "img/hongbao.41c6644c.svg";